import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'popups.returnOrder.title',
		defaultMessage: 'Return products',
	},
	description: {
		id: 'popups.returnOrder.description',
		defaultMessage: 'Please, select the products you wish to return',
	},
	returnTypeLabel: {
		id: 'returnAuthCreateForm.step1.returnTypeLabel',
		defaultMessage: 'Why?',
	},
	continueButtonText: {
		id: 'returnAuthCreateForm.step1.continueButton.text',
		defaultMessage: 'Return {number, plural, =0 {products} one {# product} other {# product(s)}}',
	},
	storeCreditLabel: {
		id: 'returnAuthCreateForm.step1.storeCreditLabel',
		defaultMessage: 'Store credit',
	},
	creditCardLabel: {
		id: 'returnAuthCreateForm.step1.creditCardLabel',
		defaultMessage: 'Your original payment method',
	},
	giftCertificateLabel: {
		id: 'returnAuthCreateForm.step1.giftCertificateLabel',
		defaultMessage: 'Gift Certificate',
	},
});
